import { getBus } from '@jiveworld/minibus';

const globalMinibusInstance = getBus('global');

(window as any).bus = globalMinibusInstance;

export default globalMinibusInstance;
